<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Registrar surtido de requisiciones
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Almacén origen:</label>
                <CSelect
                  :value.sync="almacen_origen_id"
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="
                    almacenes
                      .filter((ff) => ff.ubicacion_id === ubicacionRaiz)
                      .filter((ff) => ff.value !== almacen_destino_id)
                  "
                  placeholder="Selecciona un almacén"
                  @update:value="updateAlmacenOrigen"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Almacén destino:</label>
                <CSelect
                  :value.sync="almacen_destino_id"
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="
                    almacenes.filter((ff) => ff.value !== almacen_origen_id)
                  "
                  placeholder="Selecciona un almacén"
                  @update:value="updateAlmacenDestino"
                />
              </CCol>
            </CRow>
            <hr class="my-4 line" />
            <CRow>
              <CCol sm="12">
                <div
                  v-if="isLoading"
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow">
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                  </div>
                </div>
                <CDataTable
                  v-else
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fields"
                >
                  <template #checkbox="{ item, index }">
                    <td class="py-2">
                      <div class="form-check">
                        <input
                          class="form-check-input cursor-pointer"
                          type="checkbox"
                          v-model="item.surtir"
                          :id="'check-' + index"
                        />
                      </div>
                    </td>
                  </template>
                  <template #traspasar="{ item, index }">
                    <td class="py-2">
                      <input
                        type="number"
                        :class="[
                          'form-control',
                          {
                            'is-invalid':
                              $v.detalles.$each[index].cantidad_traspasar
                                .$error,
                          },
                        ]"
                        min="0"
                        :max="item.inventario_origen || 0"
                        :readonly="!item.inventario_origen"
                        v-model="item.cantidad_traspasar"
                        @click="
                          () =>
                            (item.cantidad_traspasar =
                              item.cantidad_traspasar == 0
                                ? ''
                                : item.cantidad_traspasar)
                        "
                      />
                    </td>
                  </template>
                  <template #comprar="{ item, index }">
                    <td class="py-2">
                      <input
                        type="number"
                        :class="[
                          'form-control',
                          {
                            'is-invalid':
                              $v.detalles.$each[index].cantidad_comprar.$error,
                          },
                        ]"
                        min="0"
                        v-model="item.cantidad_comprar"
                        @click="
                          () =>
                            (item.cantidad_comprar =
                              item.cantidad_comprar == 0
                                ? ''
                                : item.cantidad_comprar)
                        "
                      />
                    </td>
                  </template>
                  <template #proveedor="{ item, index }">
                    <td class="py-2">
                      <select
                        :class="[
                          'custom-select',
                          {
                            'is-invalid':
                              $v.detalles.$each[index].proveedor.$error,
                          },
                        ]"
                        v-model="item.proveedor"
                      >
                        <option selected disabled value="">
                          Selecciona un proveedor
                        </option>
                        <option
                          v-for="option in proveedores"
                          v-bind:value="option.value"
                          :key="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </td>
                  </template>
                  <template #cancel="{ item }">
                    <td class="py-2">
                      <CButton
                        color="danger"
                        square
                        size="sm"
                        @click="limpiar(item)"
                        >Limpiar</CButton
                      >
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter
            v-if="!isLoadingPage"
            class="d-flex justify-content-center"
          >
            <router-link
              :to="{ name: 'OrdenesCompra', params: { config: config } }"
            >
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>
            <CButton
              v-if="!isLoading"
              @click="registrarSurtido"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Traspasos"
      :centered="true"
      color="success"
      :show.sync="successModal"
      >Guardado con éxito.
      <template #footer>
        <CButton @click="successModal = false" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Error"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

import "vue-select/dist/vue-select.css";
import moment from "moment";

const fields = [
  { key: "checkbox", label: "", _style: "width:1%" },
  { key: "producto", _style: "width:20%" },
  { key: "unidad", _style: "width:10%" },
  { key: "cantidad_solicitada", _style: "width:10%" },
  { key: "inventario_origen", _style: "width:10%" },
  { key: "inventario_destino", _style: "width:10%" },
  { key: "traspasar", _style: "width:10%" },
  { key: "comprar", _style: "width:10%" },
  { key: "proveedor", _style: "width:20%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false,
  },
];

export default {
  name: "SurtirOrdenCompra",
  components: {},
  mixins: [validationMixin],
  data() {
    return {
      config: this.$route.params.config,
      almacen_origen_id: "",
      almacen_destino_id: "",
      detalles: [],
      fields,
      almacenes: [],
      proveedores: [],
      isLoading: false,
      isLoadingPage: false,
      successModal: false,
      warningModal: false,
      error: "",
    };
  },
  validations: {
    detalles: {
      $each: {
        cantidad_traspasar: {
          some: (value, data) => {
            if (!data.inventario_origen) return true;
            return value > 0 || data.cantidad_comprar > 0;
          },
        },
        cantidad_comprar: {
          some: (value, data) => {
            return data.surtir || value > 0 || data.cantidad_traspasar > 0;
          },
        },
        proveedor: {
          required: requiredIf((s) => {
            return s.cantidad_comprar > 0;
          }),
        },
      },
    },
  },
  watch: {
    ubicacionRaiz: function () {
      this.updateCombos();
    },
  },
  created() {
    this.$store.dispatch("getNanoid");
    this.isLoadingPage = true;
    const serv = [
      this.$store.dispatch("customHTTP", {
        schema: "almacenes",
        filter: {
          wherein: [
            {
              field: "payload->ubicacion_id",
              value: [...this.ubicacionesRaizValue],
            },
          ],
        },
      }),
      this.$store.dispatch("customHTTP", {
        schema: "proveedores",
      }),
    ];
    Promise.all(serv)
      .then(([almacenes, proveedores]) => {
        this.almacenes = almacenes.data.map((almacen) => {
          return {
            value: almacen.id,
            label: almacen.payload.nombre,
            ubicacion_id: almacen.payload.ubicacion_id,
          };
        });
        this.proveedores = proveedores.data.map((proveedor) => {
          return { value: proveedor.id, label: proveedor.payload.nombre };
        });
      })
      .finally(() => (this.isLoadingPage = false));
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation?.value ?? "";
    },
    documentosCompra() {
      let newDate = moment().format("YYYY-MM-DD HH:mm:ss");
      return this.detalles
        .filter((detalle) => {
          return detalle.cantidad_comprar > 0;
        })
        .reduce((acc, detalle) => {
          const proveedor_id = detalle.proveedor;
          if (proveedor_id) {
            const index = acc.find((a) => a.proveedor_id == proveedor_id);
            if (index) {
              index.detalles.push({
                producto_id: detalle.producto_id,
                cantidad: parseInt(detalle.cantidad_comprar),
              });
            } else {
              acc.push({
                proveedor_id: proveedor_id,
                detalles: [
                  {
                    producto_id: detalle.producto_id,
                    cantidad: parseInt(detalle.cantidad_comprar),
                  },
                ],
              });
            }
          }
          return acc;
        }, [])
        .map(({ detalles, ...documento }) => {
          return {
            schema: "ordenes_compra",
            payload: {
              encabezado: {
                fechahora: newDate,
                almacen_id: this.almacen_destino_id,
                ubicacion_raiz_id: this.ubicacionRaiz,
                ...documento,
              },
              detalles,
            },
          };
        });
    },
    documentosTraspaso() {
      let newDate = moment().format("YYYY-MM-DD HH:mm:ss");
      return this.detalles
        .filter((detalle) => {
          return detalle.cantidad_traspasar > 0;
        })
        .reduce((acc, detalle) => {
          if (acc.length == 0) {
            acc[0] = { detalles: [] };
          }
          acc[0].detalles.push({
            producto_id: detalle.producto_id,
            cantidad: parseInt(detalle.cantidad_traspasar),
          });
          return acc;
        }, [])
        .map(({ detalles, ...documento }) => {
          return {
            schema: "traspasos",
            payload: {
              encabezado: {
                fechahora: newDate,
                almacen_origen_id: this.almacen_origen_id,
                almacen_destino_id: this.almacen_destino_id,
                ubicacion_raiz_id: this.ubicacionRaiz,
                ...documento,
              },
              detalles,
            },
          };
        });
    },
    documentosSurtir() {
      return {
        requisiciones: this.detalles
          .filter((detalle) => {
            return detalle.surtir == true;
          })
          .map((detalle) => {
            return {
              producto_id: detalle.producto_id,
              requisiciones_id: detalle.folio,
            };
          }),
      };
    },
    ubicacionesRaizValue() {
      return this.$store.getters.rootLocationsIds;
    },
  },
  methods: {
    alert(v) {
      console.log(v);
    },
    vNumber(v) {
      return Number(v.target.value);
    },
    updateAlmacenOrigen(value) {
      this.almacen_origen_id = value;
      if (this.almacen_destino_id) {
        this.obteneProductos();
      }
    },
    updateAlmacenDestino(value) {
      this.almacen_destino_id = value;
      this.obteneProductos();
    },
    obteneProductos() {
      this.$v.$reset();
      this.isLoading = true;
      this.$store
        .dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "surtido_requisiciones",
            params: {
              ubicaciones: [this.ubicacionRaiz],
              almacen_origen: this.almacen_origen_id,
              almacen_destino: this.almacen_destino_id,
            },
          },
        })
        .then((response) => {
          this.detalles = response.data.map((detalle) => {
            return {
              ...detalle,
              inventario_origen: detalle.inventario_origen || "",
              inventario_destino: detalle.inventario_destino || "",
              cantidad_traspasar: 0,
              cantidad_comprar: 0,
              proveedor: "",
            };
          });
        })
        .finally(() => (this.isLoading = false));
    },
    limpiar(item) {
      item.cantidad_traspasar = 0;
      item.cantidad_comprar = 0;
      item.proveedor = "";
    },
    updateCombos() {
      this.isLoadingPage = true;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [...this.ubicacionesRaizValue],
              },
            ],
          },
        }),
      ];

      Promise.all(ubi)
        .then(([almacenes]) => {
          this.almacenes = almacenes.data.map((almacen) => {
            return {
              value: almacen.id,
              label: almacen.payload.nombre,
              ubicacion_id: almacen.payload.ubicacion_id,
            };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    },
    registrarSurtido() {
      this.$v.detalles.$touch();

      const alguno_valido = Object.values(this.$v.detalles.$each.$iter).some(
        (d) => {
          return !d.cantidad_comprar.$error &&
            !d.cantidad_traspasar.$error &&
            !d.proveedor.$error
            ? true
            : false;
        }
      );

      if (alguno_valido) {
        this.requestGuardar();
      }
    },
    async requestGuardar() {
      this.isLoading = true;

      if (this.documentosTraspaso.length) {
        const traspasos = await this.$store.dispatch(
          "customDocumentoAddHTTP",
          this.documentosTraspaso
        );
        if (traspasos.data.some((s) => s.status == "fail")) {
          this.warningModal = true;
          this.error = traspasos.data
            .filter((f) => f.status == "fail")
            .map((m) => m.message)
            .join("\n");
          this.isLoading = false;
          return;
        }
      }
      debugger;
      const documentos = [
        ...(this.documentosCompra.length
          ? [
              this.$store.dispatch(
                "customDocumentoAddHTTP",
                this.documentosCompra
              ),
            ]
          : []),
      ];
      if (this.documentosSurtir.requisiciones.length) {
        documentos.push(
          this.$store.dispatch("httpAny", {
            endpoint: "requisiciones:surtir",
            body: this.documentosSurtir,
          })
        );
      }

      Promise.all(documentos).finally(() => {
        this.isLoading = false;
        if (!this.warningModal) {
          this.successModal = true;
        }
        this.obteneProductos();
      });
    },
  },
};
</script>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
